import React, { useState, useEffect } from "react";
import "./PackingHistory.css";
import {
  Card,
  CardContent,
  Container,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/Button/button";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import SearchIcon from "@mui/icons-material/Search";
import { getPackingHistoryData, printPackingDetails } from "./service";
import { images } from "../../config/images";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { userFootFallTracking } from "../FootFallReport/services";

const PackingHistory = () => {
  const navigate = useNavigate();
  const [getHistoryData, setGetHistoryData] = useState([]);
  const [Count, setCount] = useState("");
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const initiallValue = {
    created_at__date: "",
    created_at: "",
    batch_no: "",
    product__product_name: "",
    plant__name: "",
    shift__shift_name: "",
    size__size: "",
    extruder__name: "",
    printer__name: "",
    pack_no: "",
    no_of_prints :"",
    quantity: "",
    created_by__email: "",
  };
  const [searchText, setSearchText] = useState(initiallValue);
  const [isPrinting, setisPrinting] = useState(false);
  const [isPrintingDone, setisPrintingDone] = useState(false);
  const [PrintAgainstatus, setPrintAgainstatus] = useState(false);
  const [PairId, setPairId] = useState("");
  const [printerId, setPrinterId] = useState("");
  const {  is_normal_user } = useSelector(
    (state) => state.userState
  );

  useEffect(() => {
    printData();
  }, [searchText, rowsPerPage, page]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const printData = async () => {

      const searchParams = {
        search: searchText,
        page: page,
        rowsPerPage: rowsPerPage,
      };
  
      console.log("serach paramas", searchParams)
      const resp = await getPackingHistoryData(searchParams);
      try {
        if (resp.status == 200 || resp.status == 201) {
          setGetHistoryData(resp.data.results);
          setCount(resp.data.count);
        }
      } catch (error) {
        setGetHistoryData([]);
      }
    
  

  };

  useEffect(() => {
    let intervalId = null;

    const callUserFootFallTracking = () => {
      const moduleList = JSON.parse(localStorage.getItem("moduleList"));
      if (moduleList) {
        const module = moduleList.find((m) => m.name === "Packing History");
        if (module) {
          const params = { module_id: module.id };
          try {
            userFootFallTracking(params);
          } catch (error) {
            console.error("Error calling userFootFallTracking:", error);
          }
        }
      }
    };

    const startTracking = () => {
      if (!intervalId) {
        console.log("▶️ Start API interval");
        callUserFootFallTracking(); // call immediately
        intervalId = setInterval(callUserFootFallTracking, 5 * 60 * 1000);
      }
    };

    const stopTracking = () => {
      if (intervalId) {
        console.log("⏹ Stop API interval");
        clearInterval(intervalId);
        intervalId = null;
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        stopTracking(); // stop when tab hidden/minimized
      } else {
        startTracking(); // resume when tab active
      }
    };

    // Setup listener
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Start tracking immediately if tab is visible
    if (!document.hidden) {
      startTracking();
    }

    return () => {
      stopTracking();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  const handleSearchData = async (e) => {
    const { name, value } = e.target;
    console.log("name search", name, value)
    setSearchText({ ...searchText, [name]: value });
  };

  const PrintAgainHandle = async (id, printer) => {
    if(is_normal_user){
      toast.error("You don't have access");
      return;
    }
    setisPrinting(true);
    setPairId(id);
    setPrinterId(printer);
    const params = {
      packing_id: id,
      printer: printer,
    };
    try {
      const Api = await printPackingDetails(params);

      if (Api.data.success == true) {
        setisPrinting(false);
        setisPrintingDone(true);

        console.log("Apicall sucessfully", Api.data);
      }
    } catch (e) {
      // setisPrintingDone(true)
      // setisPrinting(false)

      console.log("Error from PrintAgain....");
    }
  };

  return (
    <>
      <div className="containerWrap">
        <ToastContainer />
        <Container maxWidth="xxl">
          <div className="packingHeader-wrap">
            <div className="packingTitle-wrap">
              <KeyboardBackspaceIcon
                onClick={() => navigate("/packing")}
                className="backArrow"
              />
              <Typography
                variant="h5"
                className="packingTitle"
                gutterBottom
                onClick={() => navigate("/packing")}
              >
                Packing History
              </Typography>
            </div>
          </div>
          <div className="packinghistory-table">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="packingHistory-tableheadCell">
                    Date of Printing
                  </TableCell>
                  <TableCell className="packingHistory-tableheadCell">
                    Time of Printing
                  </TableCell>
                  <TableCell className="packingHistory-tableheadCell">
                    Batch No.
                  </TableCell>
                  <TableCell className="packingHistory-tableheadCell">
                    Product
                  </TableCell>
                  <TableCell className="packingHistory-tableheadCell">
                    Plant
                  </TableCell>
                  <TableCell className="packingHistory-tableheadCell">
                    Size
                  </TableCell>
                  <TableCell className="packingHistory-tableheadCell">
                    Extruder
                  </TableCell>
                  <TableCell className="packingHistory-tableheadCell">
                    Line
                  </TableCell>
                  <TableCell className="packingHistory-tableheadCell">
                    Printer
                  </TableCell>
                  <TableCell className="packingHistory-tableheadCell">
                    Shift
                  </TableCell>
                  <TableCell className="packingHistory-tableheadCell">
                    Quantity
                  </TableCell>
                  <TableCell className="packingHistory-tableheadCell">
                    Pack No.
                  </TableCell>
                  <TableCell className="packingHistory-tableheadCell">
                    No of Prints
                  </TableCell>
                  <TableCell className="packingHistory-tableheadCell">
                    Created By
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Date of Printing"
                      name="created_at__date"
                      value={searchText.created_at__date}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Time of Printing"
                      name="created_at"
                      value={searchText.created_at}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Batch No."
                      name="batch_no"
                      value={searchText.batch_no}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Product"
                      name="product__product_name"
                      value={searchText.product__product_name}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Plant"
                      name="plant__name"
                      value={searchText.plant__name}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Size"
                      name="size__size"
                      value={searchText.size__size}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Extruder"
                      name="extruder__name"
                      value={searchText.extruder__name}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Line"
                      name="line"
                      value={searchText.line}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Printer"
                      name="Printer"
                      value={searchText.printer__name}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Shift"
                      name="shift__shift_name"
                      value={searchText.shift__shift_name}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Quantity"
                      name="quantity"
                      value={searchText.quantity}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Pack No."
                      name="pack_no"
                      value={searchText.pack_no}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="No of Prints	"
                      name="no_of_prints"
                      value={searchText.no_of_prints}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                  <TableCell className="search-table-row">
                    <SearchIcon className="search-icon" />
                    <input
                      type="search"
                      placeholder="Created By"
                      name="created_by__email"
                      value={searchText.created_by__email}
                      onChange={handleSearchData}
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="packingHistory-tablebody">
                {getHistoryData.map((e) => {
                  return (
                    <TableRow className="packingHistory-tablebodyRow">
                      <TableCell className="packingHistory-tablebodyCell">
                        {e.created_at.split("T")[0]}
                      </TableCell>
                      <TableCell className="packingHistory-tablebodyCell">
                      {e.created_at.split("T")[1].split(".")[0]}
                      </TableCell>
                      <TableCell className="packingHistory-tablebodyCell">
                        {e.batch_no}
                      </TableCell>
                      <TableCell className="packingHistory-tablebodyCell">
                        {e.product}
                      </TableCell>
                      <TableCell className="packingHistory-tablebodyCell">
                        {e.plant}
                      </TableCell>
                      <TableCell className="packingHistory-tablebodyCell">
                        {e.size}
                      </TableCell>
                      <TableCell className="packingHistory-tablebodyCell">
                        {e.extruder}
                      </TableCell>
                      <TableCell className="packingHistory-tablebodyCell">
                        {e.line}
                      </TableCell>
                      <TableCell className="packingHistory-tablebodyCell has-printer-button">
                        {e.printer_name}
                        <div
                          className={"page-header-button printer-icon"}
                          onClick={() => {
                            PrintAgainHandle(e.id, e.printer);
                          }}
                        >
                          <img
                            src={images.printer}
                            className={e.is_printed ? "" : ""}
                            alt=""
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </TableCell>
                      <TableCell className="packingHistory-tablebodyCell">
                        {e.shift}
                      </TableCell>
                      <TableCell className="packingHistory-tablebodyCell">
                        {e.quantity}
                      </TableCell>
                      <TableCell className="packingHistory-tablebodyCell">
                        {e.pack_no}
                      </TableCell>
                      <TableCell className="packingHistory-tablebodyCell">
                        {e.no_of_prints}
                      </TableCell>
                      <TableCell className="packingHistory-tablebodyCell">
                        {e.created_by}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            className="table-pagination"
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={Count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Container>

        {isPrinting ? (
          <>
            <Modal open={isPrinting} style={{ width: "300px" }}>
              <div className="popup-container">
                <Typography variant="h6">{"Printing....."}</Typography>
              </div>
            </Modal>
          </>
        ) : null}

        {isPrintingDone ? (
          <>
            <Modal open={isPrintingDone}>
              <div className="popup-container" style={{ width: "300px" }}>
                <Typography variant="h6">Printed</Typography>
                <div className="popup-buttons">
                  <Button
                    classname={"custom-button"}
                    title="Yes"
                    onClick={() => {
                      setisPrintingDone(false);
                    }}
                    style={{ marginRight: "8px" }}
                  />
                  <Button
                    classname={"border-btn"}
                    color="secondary"
                    title="No"
                    onClick={() => {
                      setPrintAgainstatus(true);
                      setisPrintingDone(false);
                    }}
                    style={{
                      border: "none",
                      backgroundColor: "#A9B0BD",
                    }}
                  />
                </div>
              </div>
            </Modal>
          </>
        ) : null}

        {PrintAgainstatus ? (
          <>
            <Modal open={PrintAgainstatus}>
              <div className="popup-container" style={{ width: "300px" }}>
                <Typography variant="h6">Print Again?</Typography>
                <div className="popup-buttons">
                  <Button
                    classname={"custom-button"}
                    title="Yes"
                    onClick={() => {
                      PrintAgainHandle(PairId, printerId);
                      setPrintAgainstatus(false);
                    }}
                    style={{ marginRight: "8px" }}
                  />
                  <Button
                    classname={"border-btn"}
                    color="secondary"
                    title="No"
                    onClick={() => {
                      window.location.reload();
                    }}
                    style={{
                      border: "none",
                      backgroundColor: "#A9B0BD",
                    }}
                  />
                </div>
              </div>
            </Modal>
          </>
        ) : null}
      </div>
    </>
  );
};

export default PackingHistory;
